var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"pull-left"},[_c('h5',[_vm._v(" "+_vm._s(_vm.$t('운영 기준정보 관리'))+" > "+_vm._s(_vm.$t(_vm.title))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }